import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './components/auth/Login';
import Unauthorized from './components/auth/Unauthorized';
import Dashboard from './components/dashboard/Dashboard';
import Layout from './components/layout/Layout';

// News Components
import NewsList from './components/News/NewsList';
import NewsForm from './components/News/NewsForm';
import NewsView from './components/News/NewsView';

// Tenders Components
import TendersList from './components/tenders/TendersList';
import TendersForm from './components/tenders/TendersForm';
import TendersView from './components/tenders/TendersView';
import ContactsForm from './components/contacts/Contactsform';
import ContactsList from './components/contacts/Contactslist';
import ContactsView from './components/contacts/Contactsview';
import RTIOfficersForm from './components/Rti/RTIOfficersForm';
import RTIOfficersList from './components/Rti/RTIOfficersList';
import RTIOfficersView from './components/Rti/RTIOfficersView';

import CirclesDivisionsView from './components/Circles-divisions/CirclesDivisionsView';
import SteelCementRatesView from './components/Steel-cement/SteelCementRatesView';
import SteelCementRatesForm from './components/Steel-cement/Steelcementratesform';
import SteelCementRatesList from './components/Steel-cement/Steelcementrateslist';
import HomepageContentForm from './components/Homepage/HomepageContentForm';
import HomepageContentList from './components/Homepage/HomepageContentList';
import CirclesDivisionsList from './components/Circles-divisions/CirclesDivisionsList';
import CirclesDivisionsForm from './components/Circles-divisions/CirclesDivisionsForm';
import AdministrationList from './components/Adminstration/AdministrationList';
import AdministrationForm from './components/Adminstration/AdministrationForm';
import AdministrationView from './components/Adminstration/Administrationview';
import GalleryForm from './components/gallery/GalleryForm';
import GalleryList from './components/gallery/GalleryList';
import GalleryView from './components/gallery/GalleryView';

// Documents Components
import DocumentsList from './components/Documents/DocumentsList';
import DocumentsForm from './components/Documents/DocumentsForm';

// Static Pages Components
import StaticPagesList from './components/StaticPages/StaticPagesList';
import StaticPagesForm from './components/StaticPages/StaticPagesForm';

// Assets Components
import AssetsList from './components/Assets/AssetsList';
import AssetsForm from './components/Assets/AssetsForm';

// Government Orders Components
import GosList from './components/GovernmentOrders/GosList';
import GosForm from './components/GovernmentOrders/GosForm';

// Downloads Components
import DownloadsList from './components/Downloads/DownloadsList';
import DownloadsForm from './components/Downloads/DownloadsForm';

// Citizen Charter
import CitizenCharterForm from './components/CitizenCharter/CitizenCharterForm';

// Contact Us Page
import ContactUsForm from './components/ContactUs/ContactUsForm';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* News Routes */}
            <Route path="news" element={<NewsList />} />
            <Route path="news/create" element={<NewsForm />} />
            <Route path="news/edit/:id" element={<NewsForm />} />
            <Route path="news/view/:id" element={<NewsView />} />
            
            {/* Tenders Routes */}
            <Route path="tenders" element={<TendersList />} />
            <Route path="tenders/create" element={<TendersForm />} />
            <Route path="tenders/edit/:id" element={<TendersForm />} />
            <Route path="tenders/view/:id" element={<TendersView />} />

            {/* Contacts Routes */}
            <Route path="contacts" element={<ContactsList />} />
            <Route path="contacts/create" element={<ContactsForm />} />
            <Route path="contacts/edit/:id" element={<ContactsForm />} />
            <Route path="contacts/public" element={<ContactsView />} />

            {/* Steel & Cement Rates Routes */}
            <Route path="steel-cement-rates" element={<SteelCementRatesList />} />
            <Route path="steel-cement-rates/create" element={<SteelCementRatesForm />} />
            <Route path="steel-cement-rates/edit/:id" element={<SteelCementRatesForm />} />
            <Route path="steel-cement-rates/public" element={<SteelCementRatesView />} />


// Admin routes
<Route path="/gallery" element={<ProtectedRoute><GalleryList /></ProtectedRoute>} />
<Route path="/gallery/create" element={<ProtectedRoute><GalleryForm /></ProtectedRoute>} />
<Route path="/gallery/edit/:id" element={<ProtectedRoute><GalleryForm /></ProtectedRoute>} />

// Public route
<Route path="/gallery/view" element={<GalleryView />} />

            // Homepage Content Routes
<Route path="/homepage-content" element={<ProtectedRoute><HomepageContentList /></ProtectedRoute>} />
<Route path="/homepage-content/create" element={<ProtectedRoute><HomepageContentForm /></ProtectedRoute>} />
<Route path="/homepage-content/edit/:id" element={<ProtectedRoute><HomepageContentForm /></ProtectedRoute>} />


{/* Administration */}
<Route path="/administration" element={<ProtectedRoute><AdministrationList /></ProtectedRoute>} />
<Route path="/administration/create" element={<ProtectedRoute><AdministrationForm /></ProtectedRoute>} />
<Route path="/administration/edit/:id" element={<ProtectedRoute><AdministrationForm /></ProtectedRoute>} />
<Route path="/administration/view" element={<AdministrationView />} />

            {/* Documents Routes */}
            <Route path="documents/:category" element={<DocumentsList />} />
            <Route path="documents/:category/create" element={<DocumentsForm />} />
            <Route path="documents/:category/edit/:id" element={<DocumentsForm />} />


            {/* Static Pages Routes */}
            <Route path="static-pages" element={<StaticPagesList />} />
            <Route path="static-pages/create" element={<StaticPagesForm />} />
            <Route path="static-pages/edit/:id" element={<StaticPagesForm />} />

            {/* Assets Routes */}
            <Route path="assets-management" element={<AssetsList />} />
            <Route path="assets-management/create" element={<AssetsForm />} />
            <Route path="assets-management/edit/:id" element={<AssetsForm />} />

            {/* Circles & Divisions Routes */}
            <Route path="circles-divisions" element={<CirclesDivisionsList />} />
            <Route path="circles-divisions/create" element={<CirclesDivisionsForm />} />
            <Route path="circles-divisions/edit/:id" element={<CirclesDivisionsForm />} />
            <Route path="circles-divisions/view" element={<CirclesDivisionsView />} />

            {/* RTI Officers Routes */}
            <Route path="rti-officers" element={<RTIOfficersList />} />
            <Route path="rti-officers/create" element={<RTIOfficersForm />} />
            <Route path="rti-officers/edit/:id" element={<RTIOfficersForm />} />
            <Route path="rti-officers/public" element={<RTIOfficersView />} />

            {/* Government Orders Routes */}
            <Route path="government-orders" element={<GosList />} />
            <Route path="government-orders/create" element={<GosForm />} />
            <Route path="government-orders/edit/:id" element={<GosForm />} />

            {/* Downloads Routes */}
            <Route path="downloads" element={<DownloadsList />} />
            <Route path="downloads/create" element={<DownloadsForm />} />
            <Route path="downloads/edit/:id" element={<DownloadsForm />} />

            {/* Citizen Charter */}
            <Route path="citizen-charter" element={<CitizenCharterForm />} />

            {/* Contact Us Page */}
            <Route path="contact-us-page" element={<ContactUsForm />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;